export const sliderSettings = {
    slidesPerView : 1,
    spaceBetween: 50,
    delay: 2000
}